module.exports = __webpack_public_path__ + "img/ghbourges_cover.8d55e1db.jpg";